<div *ngIf="loading" class="loading-container">
    <mat-progress-spinner color="accent" mode="indeterminate">
    </mat-progress-spinner>
</div>
<router-outlet></router-outlet>